import axios from 'axios';
import { get } from 'lodash';
import { stats } from '@fiverr-private/obs';
import { LOGS_KEY } from '../../../../../utils/constants';
import routes from '../../../../../shared/routes';
import { DEFAULT_RESPONSE } from '../../../../../api/personalization/StructuredApiResponse';
import { buildTrackingPath } from '../../../../../utils/bi/grafana/buildTrackingUrl';
import { BASE_PATH, EVENT_TYPES } from '../../../../../utils/bi/grafana/constants';
import { logger } from '../../../../../shared/logger';

const pickComponent = (personalizedContent, sectionName, componentName) =>
    get(personalizedContent, `sections.${sectionName}`, []).find((curr) => curr.name === componentName);

/**
 * This function fetches the PCP BE to trigger the entire fetching flow in the BE (go p13n + providers)
 * @param {*} perseusName - The containing perseus name - used to route back to its BE
 * @param {*} appName - The containing perseus app name - used to route back to its BE
 * @param {*} sectionName - The current component's section name
 * @param {*} componentName - The name of the relevant component to fetch
 * @returns The fetched component OR DEFAULT_RESPONSE in case of missing data/error
 */
export const fetchComponentContent = async ({ perseusName, appName, sectionName, componentName }) => {
    const REQUEST_NAME = `fetch_lazy_component.${sectionName}.${componentName}`;
    const fetchComponentContentAjaxUrl = routes.by_component.fetcher(sectionName, componentName);

    try {
        const startTime = Date.now();

        const { data } = await axios.post(fetchComponentContentAjaxUrl, {
            app_name: appName,
            perseus_name: perseusName,
        });

        const duration = Date.now() - startTime;
        const eventPath = getTrackingPath({ perseusName, appName, sectionName, componentName });

        eventPath && stats.time(BASE_PATH, eventPath, duration);

        const enrichedComponent = pickComponent(data, sectionName, componentName);

        return !enrichedComponent ? DEFAULT_RESPONSE : enrichedComponent;
    } catch (error) {
        logger.error(error, {
            [LOGS_KEY]: `Lazy component failed to fetch its data - ${REQUEST_NAME}`,
            componentName,
            sectionName,
            fetchedUrl: fetchComponentContentAjaxUrl,
        });

        return DEFAULT_RESPONSE;
    }
};

const getTrackingPath = ({ perseusName, appName, sectionName, componentName }) => {
    try {
        return buildTrackingPath(perseusName, appName, sectionName, EVENT_TYPES.RESPONSE_TIME);
    } catch (error) {
        logger.warn(error, {
            perseusName,
            appName,
            sectionName,
            componentName,
            eventType: EVENT_TYPES.RESPONSE_TIME,
            [LOGS_KEY]: 'Error in client buildTrackingPath',
        });
    }
};
